import React from 'react';
import Link from '@material-ui/core/Link';
import { formatDateTime } from 'utils';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Chip from '@material-ui/core/Chip';
import TableActions from 'components/facilities/UploadManager/TableActions';

const buildErrorButton = (retry) => (
    <Chip label="FAILED" style={{ color: 'red' }} variant="outlined" />
);

const buildDoneButton = () => (
    <Chip label="SUCCESS" style={{ color: 'green' }} variant="outlined" />
);

const getStatusIcon = (row, retryProcessPdf) => {
    const { analyzerStatus, processing } = row;

    if (processing) {
        return <CircularProgress size={20} />;
    }

    if (analyzerStatus == 'done') {
        return buildDoneButton();
    }

    if (analyzerStatus == 'error') {
        return buildErrorButton(() => retryProcessPdf(row));
    }
    return null;
};

const buildErrorDescription = (row) => {
    const { analyzerStatus, errorMessage } = row;

    if (analyzerStatus === 'error' && errorMessage) {
        return <Typography variant="caption">{errorMessage}</Typography>;
    }
    return null;
};

const getDocumentColumns = (retryProcessPdf, deleteFile) => [
    {
        name: 'File name',
        cell: (row) => <Link href={row.url}>{row.file.originalname}</Link>,
    },
    {
        name: 'Date created',
        selector: (row) => formatDateTime(row.created_at),
        sortable: true,
        center: true,
    },
    {
        name: 'Uploaded by',
        selector: (row) => row.uploadedBy.name,
        center: true,
    },
    {
        name: 'Processed status',
        cell: (row) => getStatusIcon(row),
        center: true,
    },
    {
        name: 'Error message',
        cell: (row) => buildErrorDescription(row),
        wrap: true,
    },
    {
        cell: (row) => (
            <TableActions
                row={row}
                deleteFile={() => deleteFile(row)}
                retryProcess={() => retryProcessPdf(row)}
            />
        ),
        center: true,
    },
];

export default getDocumentColumns;
